import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Col from 'react-bootstrap/Col';
import CloseIcon from "./closeIcon";

function Chips({ selectedValues, onRemoveValue, allValues }) {
    const handleRemoveValue = (value) => {
        onRemoveValue(value);
    };

    function showLabel(id) {
        return allValues.find((value) => value.value === id).label;
    }

    return (
       selectedValues.map((id, index) => (
                <Col xs="auto" key={index}>
                    <Badge
                        variant="primary"
                        onClick={() => handleRemoveValue(id)}
                        className="tw-py-2 tw-px-4 tw-flex tw-items-center tw-justify-center tw-rounded-[48px] tw-min-h-[32px] tw-text-sm tw-mr-4 tw-border-2 tw-border-solid tw-border-white"
                        pill
                        style={{ cursor: 'pointer' }}
                    >
                        <span className="tw-mr-2.5">
                            {showLabel(id)}
                        </span>
                        <CloseIcon />
                    </Badge>
                </Col>
            ))
    );
}

export default Chips;